import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { ApiModule as ConfigApiModule, BASE_PATH as BASE_PATH_CONFIG, Configuration as ConfigConfig } from '@isophi/pap-api';
import { ApiModule as MngApiModule, BASE_PATH as BASE_PATH_MNG_CONFIG, Configuration as MngConfig } from '@isophi/mng-api';
import { environment } from '../../environments/environment';
import { ApiModule as ConfigPdfApiModule, BASE_PATH as BASE_PATH_PDF_CONFIG, Configuration as PdfConfig } from '@isophi/isophi-pdfs-api';

export const basePathFactory = (): string => environment.api;

export const pdfBasePathFactory = (): string => environment.pdfApiBase;

export const configFactory = (): ConfigConfig => new ConfigConfig({ apiKeys: {} });

export const mngConfigFactory = (): MngConfig => new MngConfig({ apiKeys: {} });

export const pdfConfigFactory = (): PdfConfig => new PdfConfig({ apiKeys: {} });

@NgModule({
  imports: [ConfigApiModule, MngApiModule, ConfigPdfApiModule],
  declarations: [],
  exports: [ConfigApiModule, MngApiModule, ConfigPdfApiModule],
})
export class ApiModule {
  constructor(@Optional() @SkipSelf() parentModule: ApiModule, @Optional() http: HttpClient) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' + 'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }

  public static forRoot(): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        { provide: ConfigConfig, useFactory: configFactory },
        { provide: BASE_PATH_CONFIG, useFactory: basePathFactory },
        // management-api configuration
        { provide: MngConfig, useFactory: mngConfigFactory },
        { provide: BASE_PATH_MNG_CONFIG, useFactory: () => environment.managementApiBase },
        { provide: PdfConfig, useFactory: pdfConfigFactory },
        { provide: BASE_PATH_PDF_CONFIG, useFactory: pdfBasePathFactory },
      ],
    };
  }
}
